import * as MoneyUtil from "../../../js/util/money.js"
import $ from "jquery"

$(".js-bulk-credit-type-radio-container input[type=radio]").change(function () {
  const recipientsCountInputContainer = $(".js-bulk-credit-recipients-count-input-container")
  const isEvenSplit = this.value === "even_split"

  if (isEvenSplit) {
    recipientsCountInputContainer.removeClass("js-hidden")
  } else {
    recipientsCountInputContainer.addClass("js-hidden")
    recipientsCountInputContainer.find("input").val("")
  }

  renderRecipientAmountPreview()
})

$(".js-bulk-credit-recipients-count-input").on("input", renderRecipientAmountPreview)
$(".js-bulk-credit-total-amount-input").on("input", renderRecipientAmountPreview)

function renderRecipientAmountPreview() {
  const currentTotalStr = $(".js-bulk-credit-total-amount-input").val()
  const currentTotalCents = MoneyUtil.parseDollarsToCents(currentTotalStr)

  const recipientsTotalStr = $(".js-bulk-credit-recipients-count-input").val()
  const recipientsTotal = parseFloat(recipientsTotalStr)

  let previewText
  if (currentTotalCents == null || Number.isNaN(recipientsTotal)) {
    previewText = ""
  } else {
    const centsPerRecipient = currentTotalCents / recipientsTotal
    previewText = `Each recipient will receive ${MoneyUtil.formatCentsAsUsd(centsPerRecipient)}`
  }

  $(".js-recipient-amount-preview").text(previewText)
}
